import { IWindowService } from 'angular';
import { ImUser } from 'Src/ng2/shared/services/im-models/im-user';
import nvDirectivesModule from '../nv.directives.module';
import { Auth } from './../../../../ng2/shared/auth/auth.service';

angular.module(nvDirectivesModule).controller('nvAccountManagerController', accountManagerCtrl);

export default function accountManagerCtrl($window: IWindowService, Auth: Auth, ImUser: ImUser) {
  this.profilePic = ImUser.getProfilePic(this.currentUser);

  this.reportIssues = () => $window.FreshWidget.show();

  this.logout = function() {
    Auth.logout();
  };
}
